import React, { useState } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import Event202404_contentList from './Event202404_contentList';
import moment from 'moment';
import '../../css/event202403.css';

const Event202404_newContent = (props) => {
  const [cp, setCp] = useState('aniplus');
  const { imgUrl } = props;

  const _changeCp = (cp) => {
    setCp(cp);
  };
  const _eventAttend = () => {
    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

    if (today >= '2024-04-02 18:00:00') {
      window.open('https://forms.gle/rnmHTuERbyZP7RCg6', '', '');
    } else {
      alert('04월 02일 18시 이후에 응모가 가능합니다.');
    }
  };
  return (
    <>
      <div className="event_head">
        <h3>애니플러스 신작 이벤트</h3>
        {/* <button type="button" className="btnClose">
          <img src="/img/detail_img/close_1.png" alt="닫기" />
        </button> */}
      </div>
      <div className="eventCon">
        <a name="top"></a>
        {/* <!-- 이벤트 20240318 --> */}
        <div className="event240318">
          <div className="main">
            <img
              src={imgUrl + '/img/event/event202404/backimg_1_2.png'}
              alt="2분기를 지켜라 합동 연합 작전 개시"
              className="img_web"
            />
            <img
              src={imgUrl + '/img/event/event202404/m_backimg_1_2.png'}
              alt="2분기를 지켜라 합동 연합 작전 개시"
              className="img_m"
            />
            <ul className="event_tabs">
              <li
                className="tab-link on"
                data-tab="tab-1"
                onClick={() => _changeCp('aniplus')}
              >
                <img
                  src={
                    cp === 'aniplus'
                      ? imgUrl + '/img/event/event202404/tap1_on.png'
                      : imgUrl + '/img/event/event202404/tap1_off.png'
                  }
                  alt="애니플러스 특수부대"
                  className="img_web"
                />
                <img
                  src={
                    cp === 'aniplus'
                      ? imgUrl + '/img/event/event202404/m_tap3_on.png'
                      : imgUrl + '/img/event/event202404/m_tap3_off.png'
                  }
                  alt="애니플러스 특수부대"
                  className="img_m"
                />
              </li>
              <li
                className="tab-link"
                data-tab="tab-2"
                onClick={() => _changeCp('animax')}
              >
                <img
                  src={
                    cp === 'animax'
                      ? imgUrl + '/img/event/event202404/tap2_on.png'
                      : imgUrl + '/img/event/event202404/tap2_off.png'
                  }
                  alt="애니맥스 특수부대"
                  className="img_web"
                />
                <img
                  src={
                    cp === 'animax'
                      ? imgUrl + '/img/event/event202404/m_tap4_on.png'
                      : imgUrl + '/img/event/event202404/m_tap4_off.png'
                  }
                  alt="애니맥스 특수부대"
                  className="img_m"
                />
              </li>
            </ul>
          </div>
          <div className="eventBody">
            {/* 애니플러스 */}
            <div
              id="tabCont1"
              className="tab-content on"
              style={{ display: cp === 'aniplus' ? 'block' : 'none' }}
            >
              <div className="listWrap">
                <div className="list_tit">
                  <div className="inner">
                    <img
                      src={imgUrl + '/img/event/event202404/aniplus_tit_bg.png'}
                    />
                    <h2>1차 선발대 출동 : 3월 29일(금) 18시</h2>
                  </div>
                </div>
                <Event202404_contentList eventCode={1} cp={cp} />
                <div className="list_tit">
                  <div className="inner">
                    <img
                      src={imgUrl + '/img/event/event202404/aniplus_tit_bg.png'}
                    />
                    <h2>2차 선발대 출동 : 4월 2일(화) 18시</h2>
                  </div>
                </div>
                <Event202404_contentList eventCode={2} cp={cp} />
              </div>
            </div>
            {/* 애니멕스 */}
            <div
              id="tabCont2"
              className="tab-content"
              style={{ display: cp === 'animax' ? 'block' : 'none' }}
            >
              <div className="listWrap">
                <div className="list_tit">
                  <div className="inner">
                    <img
                      src={imgUrl + '/img/event/event202404/animax_tit_bg.png'}
                    />
                    <h2>1차 선발대 출동 : 3월 29일(금) 18시</h2>
                  </div>
                </div>
                <Event202404_contentList eventCode={1} cp={cp} />
              </div>
              <div className="listWrap">
                <div className="list_tit">
                  <div className="inner">
                    <img
                      src={imgUrl + '/img/event/event202404/animax_tit_bg.png'}
                    />
                    <h2>2차 선발대 출동 : 4월 2일(화) 18시</h2>
                  </div>
                </div>
                <Event202404_contentList eventCode={2} cp={cp} />
              </div>
            </div>
          </div>
          <div className="btm">
            <img
              src={imgUrl + '/img/event/event202404/backimg_3.png'}
              alt="경품내용 및 주의사항"
              className="img_web"
            />
            <img
              src={imgUrl + '/img/event/event202404/m_backimg_3.png'}
              alt="경품내용 및 주의사항"
              className="img_m"
            />
          </div>
          <div className="btn_apply">
            <a
              onClick={_eventAttend}
              style={{ cursor: 'pointer' }}
              className="img_web"
            >
              <img
                src={imgUrl + '/img/event/event202404/btn_go.png'}
                alt="응모하기"
              />
            </a>
            <a
              onClick={_eventAttend}
              style={{ cursor: 'pointer' }}
              className="img_m"
            >
              <img
                src={imgUrl + '/img/event/event202404/m_btn_go.png'}
                alt="응모하기"
              />
            </a>
          </div>
        </div>
      </div>
    </>
    // <div>
    //   <span onClick={() => _changeCp('aniplus')}>애니프러스</span>
    //   <span onClick={() => _changeCp('animax')}>애니맥스</span>
    //   <div>
    //     <Event202404_contentList eventCode={1} cp={cp} />
    //   </div>
    // </div>
  );
};

export default shopContext(withRouter(Event202404_newContent));
